// --------------------------------------------------------------
// Created On: 2021-09-21
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import Modal from "react-bootstrap/Modal";

// Generic modal body.
export default function ModalBody(props: Props): Component {
  return <Modal.Body className={props.className || undefined}>{props.children}</Modal.Body>;
}

interface Props {
  className?: string;
  children?: React.ReactNode;
}
